import { ThemeProvider } from '@emotion/react';
import React from 'react';
import { Script } from 'gatsby';

import { ConsentProvider } from '~/context/ConsentContext';
import { GravityFormsProvider } from '~/context/GravityFormsContext';
import { StickyProvider } from '~/context/StickyContext';
import { LocationProvider } from '~/context/LocationContext';
import { LocationPickerProvider } from '~/context/LocationPickerContext';
import { UserContextProvider } from '~/context/UserContext';
import { CartContextProvider } from '~/context/CartContext';

import ReCaptcha from '~/components/ReCaptcha';
import CookieConsent from '~/components/consent/CookieConsent';
import THEME from '~/theme';

const RootProviders = ({ element }) => (
    <ConsentProvider>
        <LocationProvider>
            <LocationPickerProvider>
                <UserContextProvider>
                    <CartContextProvider>
                        <GravityFormsProvider>
                            <StickyProvider>
                                <ThemeProvider theme={THEME}>
                                    {element}
                                </ThemeProvider>
                            </StickyProvider>
                        </GravityFormsProvider>
                    </CartContextProvider>
                </UserContextProvider>
            </LocationPickerProvider>
        </LocationProvider>
    </ConsentProvider>
);

const PageProviders = ({ element, props }) => (
    <LocationProvider pageProps={props}>
        <Script src={`https://www.google.com/recaptcha/api.js`} />
        {element}
        <ReCaptcha />
        <CookieConsent />
    </LocationProvider>
);

export const wrapRootElement = ({ element }) => (
    <RootProviders element={element} />
);

export const wrapPageElement = ({ element, props }) => (
    <PageProviders element={element} props={props} />
);
